<template>
  <div class="letterEntry__header entryHeader" :class="{ android: isAndroid }">
    <!-- ステップ -->
    <step-chart class="entryHeader__stepChart" v-if="!disableSteps" :steps="steps" :active="getStep()"></step-chart>
    <div class="contentTitle">
      <p>{{isSubscPresent ? '申込商品' : '購入商品'}}</p>
    </div>

    <!-- 商品詳細 -->
    <div class="productData">
      <div class="productData__detail">
        <div class="imagearea">
          <uranai-img
            data-clip-path-support="true"
            data-size="md"
            size="md"
            :alt="item.item_name"
            :src="item.pack_image"
          ></uranai-img>
        </div>
        <div class="textarea">
          <p class="productName">{{ item.item_name }}</p>
          <p class="itemTheme">{{ item.detailed_explanation }}</p>
          <p class="counselorName">
            <span v-if="counselor.name && !specialFlg && !counselor.kaonashi_flg && !packageFlg">占い師：{{counselor.name}}</span>
          </p>
          <div class="textarea__tag u-mg-b-1" v-if="!isSubscPresent">
            <div class="service_type" v-if="item.service_type_str != ''">
              <span class="badge">{{ item.service_type_str }}</span>
            </div>
            <div class="category" v-if="optionalTagName != '' || item.category_tag_name != ''">
              <span
                :class="'badge u-tag-'+item.category_tag_id"
                v-if="!specialFlg"
              >{{ item.category_tag_name }}</span>
              <span
                :class="'badge u-opttag-'+optionalTagId"
                v-else-if="optionalTagId && optionalTagName"
              >{{ optionalTagName }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="productData__theme">
        <p class="itemTheme">{{ item.detailed_explanation }}</p>
      </div>-->
    </div>

    <!-- 特集用リストエリア -->
    <div class="productData__menulist" v-if="menuList && menuList.length > 0">
      <p class="title">特集の内容</p>
      <ul>
        <li v-for="item in menuList" :key="item">{{item}}</li>
      </ul>
    </div>

    <!-- 価格 -->
    <div class="pricingColumn colItemPrice" v-if="!isSubscPresent && !disablePrices">
      <p class="u-width-3 u-tx-sub">価格</p>
      <p class="price u-width-7">
        <template v-if="!isFree">
          <span v-price="item.price_taxin"></span>
          <span class="tax-label">（税込）</span>
        </template>
        <template v-else>
          <span>￥0</span>
        </template>
      </p>
    </div>

    <!-- ポイント利用 -->
    <div class="pricingColumn colUsePoint"
         v-if="item.earn_points && isSelectPayment && !isSubscPresent && !disablePrices && !isFree"
         :class="{ pointPurchaseEnable: pointPurchaseEnable}"
    >
      <div class="info-wrap">
        <p class="u-tx-sub point-info">
          <span class="label">ポイント利用</span>
          <span class="remain-point">保有ポイント：{{ remainPoint | commaSeparator }}pt</span>
        </p>
        <span @click="onUsePointChangeBtnClick" class="change-btn" :class="{ enable: pointPurchaseEnable && !pointSubmited && !isError }">変更</span>
      </div>

      <p class="price" :class="{ smallMess: smallMess }">
        <span v-html="usePointResult"></span>
      </p>
    </div>

    <!-- 合計金額 -->
    <div class="pricingColumn colTotalPrice" v-if="item.earn_points && isSelectPayment && !isSubscPresent && !disablePrices && !isFree">
      <p class="u-width-3 u-tx-sub">合計金額</p>
      <p class="price u-width-7">
        <span v-price="totalPrice"></span>
        <span class="tax-label">（税込）</span>
      </p>
    </div>

    <!-- 獲得ポイント -->
    <div class="pricingColumn colEarnPoint" v-if="item.earn_points && !isSubscPresent && !disablePrices && !isFree">
      <p class="u-width-3 u-tx-sub">獲得ポイント</p>
      <p class="price u-width-7">
        <span>{{ totalEarnPoint | commaSeparator }}pt</span>
      </p>
    </div>

    <!-- 使用ポイント確定 -->
    <div class="pointSubmit" v-if="item.earn_points && isSelectPayment && usePoint > 0 && !isSubscPresent && !isFree">
      <form name="frmPointPurchase" :action="pointAction">
        <template v-for="(val, key) in paymentData">
          <input type="hidden" :name="key" :value="val" :key="key"/>
        </template>
        <input type="hidden" name="use_point" :value="usePoint"/>
      </form>
      <span class="pointSubmitBtn" @click="onPointSubmit" :class="{ disable: pointSubmited }">購入を確定する</span>
    </div>

    <!-- ポイント利用選択ダイアログ -->
    <dialog-base
      :trigger="isShowPointDialog"
      @dialog-close="onPointDialogClose">
      <point-settlement
        :select-idx-receive="pointDialogSelectIdx"
        :remain-point="remainPoint"
        :item-price="item.price_taxin"
        @point-update="onUsePointUpdate"
      ></point-settlement>
    </dialog-base>

    <app-modal
      title="占いサンプル"
      @close="isShowModal=false"
      :active="isShowModal"
      :location-path="ga_location"
    >
      <div slot="header">
        <span>この画面は占いのサンプルです</span>
      </div>
      <div slot="itemdetail">
        <!-- タイトル -->
        <div class="contentTitleBar">
          <div class="category">
            <span :class="'badge u-tag-'+item.category_tag_id">{{ item.category_tag_name }}</span>
          </div>
          <p class="title_text">{{ item.item_name }}</p>
        </div>

        <!-- 画像 -->
        <div class="contentImgArea__bg u-mg-center">
          <uranai-img
            data-clip-path-support="true"
            data-size="bg"
            size="bg"
            :src="item.pack_image"
            :alt="item.item_name"
          ></uranai-img>
        </div>
        <div class="contentAdviser">
          <div class="contentAdviser__description">{{ item.detailed_explanation}}</div>
          <hr class="contentSeparatorSection u-mg-t-2">
        </div>
      </div>
      <div slot="content" class="modal__body__input special">
        <div class="storyResult">
          <app-loading
            :isLoading="sampleText.length > 0 ? false : true"
            class="u-mg-center u-mg-t-3"
          ></app-loading>
          <div v-html="sampleText" class="resultContent__special"></div>
        </div>
        <!-- 占い師 -->
        <div class="card-counselor u-mg-b-2 u-mg-t-2 u-width-10" v-if="counselorId">
          <div class="imgarea">
            <div class="img">
              <img :alt="counselor.name" :src="counselor.image_url">
            </div>
          </div>
          <div class="description">
            <p class="counselorname u-mg-b-1">占い師：{{ counselor.name }}</p>
            <p class="counselordescription">{{ counselor.profile }}</p>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as type from '@/utvStore/store/mutation-types';
import DialogBase from '@/utvStore/components/partials/dialogBase';
import PointSettlement from "@/utvStore/components/Payment/PointSettlement";

var initialLocation = location.origin + location.pathname;

export default {
  name: 'entry-form-header',
  components: {
    PointSettlement,
    DialogBase
  },
  props: {
    itemsId: { type: String, required: true },
    product: Object,
    step: { type: Number, default: 1 },
    confirm: { type: Boolean, default: false },
    isSampleText: { type: Boolean, default: false },
    counselorId: [Number, String],
    menuList: [Object, Array],
    specialFlg: { type: [Boolean, String], default: false },
    packageFlg: { type: [Boolean, String], default: false },
    optionalTagName: { type: String, default: '' },
    optionalTagId: { type: [Number, String], default: null },
    isSelectPayment: {
      type: Boolean,
      default() {
        return false
      }
    },
    paymentData: {
      type: Object,
      default() {
        return {}
      }
    },
    pointAction: {
      type: String,

    },
    userPoint: {
      type: Number,
      default() {
        return 0
      }
    },
    isError: {
      type: Boolean,
      default() {
        return false
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    isSubscPresent: {
      type: Boolean,
      default() {
        return false
      }
    },
    disableSteps: {
      type: Boolean,
      default: false,
    },
    disablePrices: { //価格とポイントを非表示
      type: Boolean,
      default: false,
    },
    isFree: {
      type: Boolean,
      default: false,
    },
    subscStatus: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      // 決済画面以外ではお支払い方法は表示しない
      displayPaymentMethod: location.pathname.includes('payment'),
      isShowModal: false,
      isShowPointDialog: false,
      sampleText: '',
      ga_location: initialLocation,
      usePoint: 0,
      pointDialogSelectIdx: 0,
      isUsePointSetted: false,
      pointSubmited: false,
      smallMess: false
    };
  },
  computed: {
    isSubscPresentEnable() {
      if(!!this.userProfile && !!this.userProfile.subscription) {
        const subsc = this.userProfile.subscription
        const stat =parseInt(subsc.status)
        if(parseInt(subsc.active) === 1
          && (stat > 0 && stat !== 2 && stat !== 4)
          && parseInt(subsc.free_buy) > 0
        ){
          return true
        }
      }
      return false
    },
    steps(){
      return [{ text: 'プロフィール入力' }, { text: this.isSubscPresent ? '確認' : 'お支払い' }, { text: this.isSubscPresent ? '申込完了' : '購入完了' }]
    },
    isAndroid() {
      return navigator.userAgent.indexOf('Android') > 0
    },
    totalPrice() {
      return this.item.price_taxin - this.usePoint
    },
    remainPoint() {
      /*
      // APIから保有ポイントを取得
      // return this.item.user_point != null ? this.item.user_point : 0
      let point = 0;
      if(this.$store.state.account != null
        && this.$store.state.account.user != null
        && this.$store.state.account.user.user_point != null
        && this.$store.state.account.user.user_point.point != null
      ) {
        point = this.$store.state.account.user.user_point.point
      }else {
        point = 0
      }
      return point
       */

      // bladeから保有ポイントを取得
      return this.userPoint
    },
    pointPurchaseEnable() {
      return this.remainPoint >= this.item.price_taxin
    },
    usePointResult() {
      this.smallMess = false
      if(this.isUsePointSetted) {
        if(this.usePoint > 0) {
          return '全額ポイントで支払う'
        }
      } else {
        // if( this.remainPoint === 0 ) {
        //   return '利用なし'
        // } else if( this.remainPoint < this.item.price_taxin) {
        if( this.remainPoint < this.item.price_taxin) {
          this.smallMess = true
          return '商品価格より少ないため<br>ご利用できません'
        }
      }
      return '利用なし'
    },
    totalEarnPoint() {
      return Math.ceil(this.totalPrice * 0.05)
    },
    ...mapState({
      accessToken: state => state.auth.accessToken,
      item: state => state.item.selected,
      card: state => state.payment.card,
      counselor: state => state.counselors.counselor
    }),
    ...mapGetters(['isLoggedIn', 'paymentTypeStr'])
  },
  mounted() {
    this.$store.dispatch(type.SELECT_ITEM, { id: parseInt(this.itemsId, 10), subsc_status: this.subscStatus });
    this.$store.dispatch(type.RESET_COUNSELORS);
    this.$store.dispatch(type.RESET_COUNSELOR);
    if (this.counselorId) {
      this.$store.dispatch(type.GET_COUNSELOR, this.counselorId);
    }
    this.getPaymentInfo();
    this.getUserInfo();
  },
  methods: {
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        const tokenData = { access_token: this.accessToken };
        return this.$store.dispatch(type.GET_PAYMENT_INFO, tokenData).then(this.$store.dispatch(type.GET_PAYMENT_HISTORY, tokenData));
      }
    },
    getUserInfo() {
      if (this.isLoggedIn && this.accessToken) {
        this.$store.dispatch(type.GET_ACCOUNT, { access_token: this.accessToken })
      }
    },
    getStep() {
      if (!this.confirm || !this.card.number) {
        return this.step;
      }
      if (this.card.number) {
        return 2;
      }
    },
    openSample() {
      // GA送信
      window.gtag('event', 'SampleText', {
        page_location: initialLocation + '/sample'
      });
      this.isShowModal = true;
      this.getSampleText(this.itemsId);
    },
    getSampleText(id) {
      if (this.sampleText != null) {
        return axios.post('/api/items/getsampletext', { items_id: parseInt(this.itemsId, 10) }).then(response => {
          if (response.status === 200 && response.data.response === 'OK') {
            this.sampleText = response.data.sample_text;
          } else {
            return Promise.reject();
          }
        });
      }
    },
    onUsePointChangeBtnClick() {
      this.isShowPointDialog = true
    },
    onUsePointUpdate(val) {
      const purchasePanel = document.querySelector('.target-payment-select')

      // indexはダイアログの並び順と違うのは「利用しない」を0にするため
      // 一部ポイント-> 2にする
      switch (val) {
        case 1: //全額ポイント使用
          this.isUsePointSetted = true
          this.usePoint = this.item.price_taxin
          break
        case 0: //ポイント利用しない
        default:
          this.usePoint = 0;
      }
      this.pointDialogSelectIdx = val
      this.isShowPointDialog = false
      this.$nextTick(() => {
        if( purchasePanel != null ){
          if(this.totalPrice <= 0) {
            purchasePanel.style.display = 'none'
          }else {
            purchasePanel.style.display = 'block'
          }
        }
      })
    },
    onPointDialogClose() {
     this.isShowPointDialog = false
    },
    onPointSubmit() {
      if(!this.pointSubmited) {
        const frm = document.forms['frmPointPurchase']
        this.pointSubmited = true
        frm.submit()
      }
    }
  },
  filters: {
    commaSeparator(val) {
      return String(val).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/variables/index";
@import "../../../../sass/commons/commonVariables.scss";

$gutter-width: 16px;

p {
  margin: 0;
}

.tax-label {
  display: inline-block;
  margin: 0 -0.8em 0 -0.9em;
  font-size: 10px;
  transform: scale(0.9);
  font-family: "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic Pro", "source-han-sans-japanese", -apple-system, BlinkMacSystemFont, sans-serif;
}
.android {
  .tax-label {
    margin: 0 -0.8em 0 -0.5em;
  }
}
.entryHeader {
  &__stepChart {
    padding: $gutter-width;
    background: black;
  }
}

.productData {
  &__detail {
    display: flex;
    margin: 16px 12px 14px 12px;

    .imagearea {
      margin-right: 12px;
      height: 88px;
    }
    .textarea {
      display: table;
      min-height: 88px;
      max-width: calc(100% - 100px);

      &__tag {
        display: flex;
      }

      .productName {
        font-size: 13px;
        font-weight: bold;
        line-height: 17px;
        color: #141414;
        margin-bottom: 4px;
      }

      .counselorName {
        line-height: 12px;
        font-size: 12px;
        margin-bottom: 4px;
      }

      .itemTheme {
        margin-bottom: 4px;
        font-size: 12px;
        line-height: 14px;
      }
    }
  }

  &__theme {
    margin: 14px 12px 16px 12px;
    .itemTheme {
    }
  }

  &__menulist {
    margin: 12px;
    padding: 16px 12px;
    background: #efeef8;
    border-radius: 4px;
    font-size: 11px;

    .title {
      font-weight: bold;
      color: #1b1363;
      line-height: 11px;
      margin-bottom: 12px;
    }

    ul {
      list-style: decimal;
      color: #1b1761;
      padding-left: 1.2em;
      line-height: 18px;
      margin: 0;
    }
  }
}

.pricingColumn,
.productPrice {
  border-top: 1px solid $gray-9;
  align-items: center;
  display: flex;
  line-height: 1em;
  padding: 14px 12px;

  .price {
    color: #ed1e79;
    font-size: 20px;
    text-align: right;

    .tax {
      font-size: 14px;
    }
  }
}
.pricingColumn {
  &.colItemPrice {
    .price {
      font-size: 18px;
    }
  }
  &.colTotalPrice {
    .price {
      font-size: 18px;
      font-weight: bold;
    }
  }
  &.colUsePoint {
    padding: 12px 12px;
    display: flex;
    justify-content: space-between;
    .point-info {
      display: inline-block;
      vertical-align: middle;
      margin-right: 2px;
      @include mq('w320') {
        margin-right: 12px;
      }
      .label {
        display: block;
        width: 100%;
        line-height: 1;
        margin-bottom: 4px;
      }
      .remain-point {
        display: block;
        width: 100%;
        font-size: 10px;
        line-height: 1;
      }
    }
    .change-btn {
      pointer-events: none;
      display: inline-block;
      font-size: 13px;
      font-weight: bold;
      padding: 6px 10px;
      line-height: 1;
      background: white;
      cursor: pointer;
      color: $gray-19;
      border: 1px solid $gray-19;
      border-radius: 5px;
      white-space: nowrap;
      &.enable {
        color: $brand-2;
        border: 1px solid $brand-2;
        pointer-events: auto;
        cursor: pointer;
      }
      @include mq('w320') {
        padding: 6px 17px;
      }
    }
    .price {
      font-size: 1em;
      span {
        text-align: left;
        display: inline-block;
        font-size: 12px;
        @include mq('w320') {
          font-size: 14px;
        }
      }
      &.smallMess {
        span {
          font-size: 11px;
          @include mq('w320') {
            font-size: 12px;
          }
        }
      }
    }
    &.pointPurchaseEnable {
      .change-btn-wrap {
        .change-btn {
          pointer-events: auto;
          color: $brand-2;
          border: 1px solid $brand-2;
        }
      }
    }
  }
  &.colEarnPoint {
    .price {
      font-size: 14px;
      font-weight: bold;
    }
  }
}

.pointSubmit {
  border-top: 1px solid $gray-9;
  width: 100%;
  padding: 32px 16px;
  .pointSubmitBtn {
    display: block;
    color: $white;
    background: $black-0;
    font-size: 14px;
    padding: 13px;
    text-align: center;
    cursor: pointer;
    &.disable {
      pointer-events: none;
      background: $gray-19;
    }
  }
}

.baloon {
  cursor: pointer;
  right: 8px;
  position: absolute;
  padding: 7px 0;
  text-align: center;
  font-size: 12px;
  color: white;
  font-weight: bold;
  top: 8px;
  z-index: 1;

  &:hover {
    opacity: 0.8;
  }

  &:after {
    content: '';
    position: absolute;
    background-image: url('/static/img/common/baloon_pink.png');
    background-repeat: no-repeat;
    background-size: 148px;
    width: 148px;
    height: 41px;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .text {
    width: 148px;
    text-indent: -8px;

    &:after {
      content: '';
      background-image: url('/static/img/common/arrow_right_white.png');
      width: 16px;
      height: 16px;
      background-size: 16px;
      position: absolute;
      margin-top: 1px;
    }
  }
}
.storyResult {
  .resultContent__special {
    background: white;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/EntryFormHeader.vue